import { Injectable } from '@angular/core'

import { FeatureEditProjectComponent } from './feature-edit-project.component'

@Injectable({ providedIn: 'root' })
export default class EditProjectDeactivateGuard  {
   canDeactivate(component: FeatureEditProjectComponent): Promise<boolean> {
      return component?.canDeactivate()
   }
}
